import React from 'react';
import { Section, SectionHeading } from './Shared';
const costs = [{
  without: 'Sin estructura de sesión',
  cost: 'Improvisación que el paciente percibe'
}, {
  without: 'Sin series por patología',
  cost: 'Cada sesión preparada desde cero'
}, {
  without: 'Sin protocolo de protección',
  cost: 'Absorbes la carga del paciente'
}, {
  without: 'Sin planificación anual',
  cost: 'Trabajo reactivo, sin estrategia'
}, {
  without: 'Sin ficha clínica',
  cost: 'Consultas sin registro ni continuidad'
}];
export const CostComparison = () => <Section data-id="element-20" data-mp="2pku9c0sebdul">
    <SectionHeading eyebrow="El coste de no tenerlo" className="mb-8" data-id="element-21" data-mp="2pkkg84c20qko">
      ¿Cuánto cuesta no tenerlo?
    </SectionHeading>

    <div className="max-w-3xl mx-auto glass-panel rounded-sm overflow-hidden divide-y divide-brand-purpleDark/10" data-id="element-22" data-mp="2klr34d0oj1l1">
      {costs.map(row => <div key={row.without} className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-4 px-5 py-2.5" data-id="element-23" data-mp="1973ubyzqn566">
          <p className="text-sm font-medium text-brand-purpleDark sm:w-1/2" data-id="element-24" data-mp="2lc3v92s5r2u3">
            {row.without}
          </p>
          <p className="text-sm text-brand-burgundy/90 sm:w-1/2" data-id="element-25" data-mp="2pbl2o1r5aa1w">{row.cost}</p>
        </div>)}
    </div>

    <p className="text-center mt-8 max-w-2xl mx-auto text-lg md:text-xl font-display italic text-brand-purpleDark" data-id="element-26" data-mp="2bephjaxmcs5h">
      “Quien tiene un sistema aplica con confianza. Quien aplica con confianza,
      crece.”
    </p>
  </Section>;